import { Component, Input, OnInit } from '@angular/core';
import { RestaurantProfile } from '../../../models/List.Restaurant';
import { ZatcaFormComponent } from './zatca-form/zatca-form.component';
import { MatDialog } from '@angular/material/dialog';
import { RestaurantService } from '../../../services/Restaurant.service';

@Component({
  selector: 'app-zatca-detials',
  templateUrl: './zatca-detials.component.html'
})
export class ZatcaDetialsComponent implements OnInit {
  @Input() restaurantProfile?: RestaurantProfile;

  constructor(
    public dialog: MatDialog,
    private service: RestaurantService,
  ) { }

  ngOnInit(): void {
  }

  openZatcaForm() {
    const dialogRef = this.dialog.open(ZatcaFormComponent, {
      width: '560px',
      data: { restaurantProfile: this.restaurantProfile }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.service.refreshDetails.next(true);
      }
    });
  }
}
